/**
 * Authentication API service
 */

import apiClient from './api';

const TOKEN_KEY = 'coach_token';

export interface AuthResponse {
  access_token: string;
  token_type: string;
  user_id: string;
  email: string;
  display_name: string | null;
}

export interface User {
  id: string;
  email: string;
  display_name: string | null;
  created_at: string;
}

export const authService = {
  /**
   * Register a new account
   */
  async signup(
    email: string,
    password: string,
    displayName?: string
  ): Promise<AuthResponse> {
    const payload: { email: string; password: string; display_name?: string } = {
      email,
      password,
    };
    if (displayName !== undefined) {
      payload.display_name = displayName;
    }
    const response = await apiClient.post<AuthResponse>('/api/auth/register', payload);
    return response.data;
  },

  /**
   * Log in with email and password
   */
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  /**
   * Retrieve the stored token from localStorage
   */
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Persist a token to localStorage
   */
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Remove the token from localStorage
   */
  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Return true when a token is present in localStorage
   */
  isAuthenticated(): boolean {
    return localStorage.getItem(TOKEN_KEY) !== null;
  },
};

export default authService;
